/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */
import { selectEmbedToken, selectTabList, selectVisuals } from 'modules/dashboard/selectors';
import { useDispatch, useSelector } from 'react-redux';
import styles from 'modules/dashboard/components/tab-container/tab-container.module.scss';
import VISUAL_MAPPER from 'modules/common/utils/visual-mapper';
import VisualCard from '../../../visual-card';
import VisualGrid from '../../../visual-grid';
import {
  selectSearchFilterList,
  selectPaceVisualFilterList,
  selectTrendTimeFilterList,
  selectTrendTimeTabularFilterList,
  selectTrendSegmentFilterList,
  selectTrendSegmentTabularFilterList,
} from '../../selectors';

const SearchVisual = ({ visualDisplayName }) => {
  const tokenDetails = useSelector(selectEmbedToken);
  const visualDetails = useSelector(selectVisuals);
  const filterList = useSelector(selectSearchFilterList);
  const paceFilterList = useSelector(selectPaceVisualFilterList);
  const trendFilterList = useSelector(selectTrendTimeFilterList);
  const trendTabularFilterList = useSelector(selectTrendTimeTabularFilterList);
  const trendSegmentFilterList = useSelector(selectTrendSegmentFilterList);
  const trendSegmentTabularFilterList = useSelector(selectTrendSegmentTabularFilterList);
  const TAB_VALUE = useSelector(selectTabList);
  //
  const dispatch = useDispatch();
  //
  const accessToken = tokenDetails?.accessToken;
  const found = visualDetails?.find((visual) => visual?.pageDisplayName === visualDisplayName);

  const getFilters = () => {
    const paceVisualDisplayName = [
      ...VISUAL_MAPPER.summaryVisualFilter,
      ...VISUAL_MAPPER.paceCancellationFilter,
      ...VISUAL_MAPPER.paceHotelSegmentFilterList,
      ...VISUAL_MAPPER.paceHotelSegmentTabularFilterList,
      ...VISUAL_MAPPER.paceHotelTabularFilterList,
      ...VISUAL_MAPPER.paceHotelVisualFilter,
      ...VISUAL_MAPPER.paceOccupiedRoomFilter,
      ...VISUAL_MAPPER.paceSegmentTabularFilterList,
      ...VISUAL_MAPPER.paceSegmentVisualFilter,
      ...VISUAL_MAPPER.paceTimeRevenueFilter,
      ...VISUAL_MAPPER.paceTimeSegmentFilterList,
    ];
    if (paceVisualDisplayName.includes(visualDisplayName)) {
      return paceFilterList;
    }
    if (VISUAL_MAPPER.trendTimeFilterList.includes(visualDisplayName)) {
      return trendFilterList;
    }
    if (VISUAL_MAPPER.trendTimeTabularFilterList.includes(visualDisplayName)) {
      return trendTabularFilterList;
    }
    if (VISUAL_MAPPER.trendHotelSegmentFilterList.includes(visualDisplayName)) {
      return trendSegmentFilterList;
    }
    if (VISUAL_MAPPER.trendHotelSegmentTabularFilterList.includes(visualDisplayName)) {
      return trendSegmentTabularFilterList;
    }
    return filterList;
  };
  return (
    <VisualGrid
      isDisplay
      visualName={found?.name}
      visual={
        <VisualCard
          cssClassName={styles.tabularVisual}
          accessToken={accessToken}
          embedUrl={found?.embedUrl}
          id={found?.reportId}
          visualName={found?.name}
          pageName={found?.pageName}
          pageDisplayName={found?.pageDisplayName}
          reportName={found?.reportName}
          filters={getFilters()}
          tab={TAB_VALUE.SEARCH}
          dispatch={dispatch}
          displayFunction={() => {}}
        />
      }
    />
  );
};

export default SearchVisual;
